import { styled, StyleSystemProps, Box } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledGiftProgress = styled(Box)``;
const giftProgressStyles: StyleSystemProps = {
  width: '100%',
  height: '100%',
  minWidth: pxToRem(270),
  minHeight: pxToRem(89),
  padding: 4,
  borderRadius: 4,
  backgroundColor: 'mono1'
};

export const styles = {
  giftProgress: giftProgressStyles
};
